import { render, staticRenderFns } from "./PreviewFileUploadAttribute.vue?vue&type=template&id=90d4bb6e&scoped=true"
import script from "./PreviewFileUploadAttribute.vue?vue&type=script&lang=js"
export * from "./PreviewFileUploadAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d4bb6e",
  null
  
)

export default component.exports